export default "__VITE_ASSET__CoFJBx6i__"